import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setAssetGrouping } from '../../../actions/assets'
import { AssetGroups } from '../../../constants/assetGroups'

function mapStateToProps(state) {
  return {
    assetGroup: state.assetInfo.assetGroup || AssetGroups.TYPE
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setAssetGrouping: assetGroup => dispatch(setAssetGrouping(assetGroup))
  }
}

class AssetGroupingSelector extends Component {
  toSentenceCase(str) {
    return str.toString().split("_").map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
  }

  toGroupValue(label) {
    return AssetGroups[label.split(" ").map(w => w.toUpperCase()).join("_")];
  }

  render() {
    return (
      <Form as={Row} className="align-items-center g-2">
        <Col xs="auto">
          <Form.Label className="mb-0">Group by</Form.Label>
        </Col>
        <Col xs="auto">
          <Form.Select
            name="assetGroupingSelector"
            value={this.toSentenceCase(this.props.assetGroup)}
            onChange={e => this.props.setAssetGrouping(this.toGroupValue(e.target.value))}
          >
            {Object.keys(AssetGroups).map(g => <option key={g}>{this.toSentenceCase(g)}</option>)}
          </Form.Select>
        </Col>
      </Form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetGroupingSelector);
